import { atom } from "recoil";
import { getcookieFunc } from "../utils/useCookies";

let FgetcookieFunc = getcookieFunc();

export const loggedIn = atom({
  key: "loggedIn",
  default: FgetcookieFunc.cookieData.accessToken ? true : false,
});

export const userInfo = atom({
  key: "userInfo",
  default: FgetcookieFunc.cookieData.userInfo
    ? JSON.parse(FgetcookieFunc.cookieData.userInfo)
    : "",
});

export const searchId = atom({
  key: "searchInput",
  default: "",
});

export const transactionClicked = atom({
  key: "clickedTransaction",
  default: "",
});

export const transactionDetail = atom({
  key: "detailsTransaction",
  default: "",
});

export const orgClicked = atom({
  key: "clickedOrg",
  default: {},
});

export const vendorDetailsClicked = atom({
  key: "vendorInfo",
  default: {},
});

export const editVendorFlag = atom({
  key: "editVendor",
  default: false,
});

export const showloader = atom({
  key: "loaderShow",
  default: false,
});

export const fileTypeSucess = atom({
  key: "fileTypeSucess",
  default: false,
});

export const fileTypeName = atom({
  key: "fileTypeName",
  default: "",
});

export const filePresigned = atom({
  key: "filePresigned",
  default: [],
});
export const fileTypeValue = atom({
  key: "fileTypeValue",
  default: "",
});

export const fileTypeOther = atom({
  key: "fileTypeOther",
  default: "",
});

export const orgID = atom({
  key: "organizationID",
  default: "",
})

export const bankDetailsClicked = atom({
  key: "bankInfo",
  default: {},
});
export const sayUploadAllDocs = atom({
  key: "say-docs-allupload",
  default: false,
});
export const checkFilledDirector = atom({
  key: "checkFilledDirector",
  default: false
})
export const declarations = atom({
  default: {
    hasSubstantialUSOwner: null,
    hasUSIncomeSource: null,
    hasUSPhoneNumber: null,
    hasUSResidenceOrMailingAddress: null,
    inCareOfOrHoldMailUS: null,
    isIncorporatedInUSA: null,
    isSubsidiaryOfUSCompany: null,
    siToUS: null,
    taxableInUS: null,
    grantedPOA: null,
  },
  key: "declarations_",
});
export const products = atom({
  key: "products",
  default: [],
});
export const productSelection = atom({
  default: "",
  key: "productSelection",
});
export const orgmode = atom({
  default: "new",
  key: "orgmode",
});
export const editactive = atom({
  default: false,
  key: "editactive",
});

export const CompanyType = atom({
  default: '',
  key: "company-type"
})
export const billingsOrgId = atom({
  default: {
    id: "",
    name: ""
  },
  key: "billingsOrgId",
});
export const notOps = atom({
  default: false,
  key: "notOps",
});

export const uboFlag = atom({
  default:false,
  key:"uboFlag"
})

export const directorsData = atom({
  default:[],
  key:'directorsData'
})

export const partners = atom({
  default:[],
  key:'partners'
})

export const orgFilters = atom({
  default:{},
  key:'orgFilters'
})

export const companyListGlobal = atom({
  default:[],
  key: 'companyListGlobal'
})

export const opsList = atom({
  default:[],
  key: 'opsList'
})

export const orgaDetails = atom({
  default:{},
  key: 'orgaDetails'
})

export const inwardPartner = atom({
  default:[],
  key: 'inwardPartner'
})

export const hasInwardBank = atom({
  default:false,
  key: "hasInwardBank"
})

export const newPartnerList = atom({
  key: "newPartnerList",
  default: {}
});